import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AppConfig } from 'src/app/app.config';
import { GenericResponse } from 'src/app/entities/various';
import { environment } from 'src/environments/environment';
import { ModelInvoice } from 'src/app/entities/invoices';
import { Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvoicesSummaryService {

    public summaryModel : ModelInvoice|undefined;
    
    construct(){
      this.summaryModel={} as ModelInvoice;
    }

    resetData(){
      this.summaryModel=undefined;
    }

    getSummary(){
      return this.summaryModel;
    }

    

    setSummaryModel(model :ModelInvoice){
        this.summaryModel=model;
    }
    
  }
